export const buttonTypes = {
    textButton: 'textButton',
    button: 'button',
    node: 'node',
};
export const SHOW_LABEL = {
    hover: 'hover',
    always: 'always',
};
export const dataHooks = {
    item: 'accordion-item',
    toggleButton: 'accordion-toggle-button',
    subtitle: 'accordion-item-subtitle',
};
export const skins = {
    standard: 'standard',
    light: 'light',
    neutral: 'neutral',
};
export const SIZES = {
    tiny: 'tiny',
    small: 'small',
    medium: 'medium',
    large: 'large',
};
export const horizontalPaddings = {
    none: 'none',
    tiny: 'tiny',
    small: 'small',
    medium: 'medium',
    large: 'large',
};
export const transitionSpeeds = {
    slow: 'slow',
    medium: 'medium',
    fast: 'fast',
};
//# sourceMappingURL=constants.js.map